import classNames from 'classnames'

export interface IInputBox {
    label?: string
    bottomLabel?: string
    type: string
    width?: string
    height?: string
    minWidth?: string
    inputID: string
    className?: string
    shadow?: string
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
    onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void
    onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void
    value?: any
    name?: string
    required?: boolean
    error?: string
    isValid?: boolean
    isFocus?: boolean
    isBlur?: boolean
    maxLength?: number
    errorStyling?: string
    placeholder?: string
}

const InputBox: React.FC<IInputBox> = ({
    label,
    bottomLabel,
    width,
    height,
    minWidth,
    type,
    inputID,
    className,
    shadow,
    onChange,
    onBlur,
    onFocus,
    value,
    name,
    required,
    error,
    isValid,
    isFocus,
    isBlur,
    maxLength,
    errorStyling,
    placeholder
}) => {
    return (
        <div className={classNames(className, required ? "h-[6.5rem]" : "pb-2", 'flex flex-col')}>
            <label
                htmlFor={inputID}
                className={classNames(
                    `font-sans mb-1 text-md font-medium text-gray-700 flex flex-row`
                )}
            >
                {label}
            </label>
            <input
                type={type}
                className={classNames(
                    `text-gray-900 text-sm px-2 `,
                    width ? width : 'w-72 ',
                    height ? height : 'h-12',
                    minWidth ? minWidth : 'min-w-[14rem]',
                    shadow ? shadow : ''
                )}
                id={inputID}
                onChange={onChange}
                onBlur={onBlur}
                onFocus={onFocus}
                value={value}
                name={name}
                maxLength={maxLength}
                required={required}
                placeholder={placeholder}
            ></input>
            <label
                htmlFor={inputID}
                className={classNames(
                    `font-sans text-sm font-normal text-center text-gray-700 pt-1`
                )}
            >
                {bottomLabel}
            </label>
            {isBlur && !isValid && (
                <p className={classNames(errorStyling, "text-red-600 font-semibold")}>*{error}</p>
            )}
        </div>
    )
}

export default InputBox
